
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getBSRSToken, getIsIntegration } from './'

const Auth = {
	isAuthenticated: () => {
		const bsrsToken = getBSRSToken()
		// const serviceToken = getAccessToken()

		return !!bsrsToken /*&& !!serviceToken*/
	},
	isIntegration: () => {
		// const o365Token = getO365Token()
		const isIntegration = getIsIntegration()
		let setIsIntegration = typeof isIntegration === 'boolean' ? isIntegration : false
		if (typeof isIntegration === 'string' && isIntegration.toLowerCase() === 'true') {
			setIsIntegration = true
		}

		if (typeof setIsIntegration === 'boolean') {
			return !!setIsIntegration
		}

	}
}

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route onUpdate={() => window.scrollTo(0, 0)} {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			return <Redirect to='/login' />
		}

		if (Auth.isIntegration() === false && props.match.url !== "/integration") {
			return <Redirect to='/integration' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			// return <Redirect to='/' />
			return <Redirect to='/searchroom' />
		}
	}} />
)

const PublicRoute = ({ component: Component, ...rest }) => {
	return <Route onUpdate={() => window.scrollTo(0, 0)} {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			// return <Redirect to='/' />
			return <Redirect to='/searchroom' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return ""
		}
	}} />
}

export {
	PrivateRoute,
	PublicRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/lib/routePermission.js